import { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";
import { PrintResourceApi } from "../generated/dashboard-client";

const printApi = new PrintResourceApi(dashboardApiConfig);

const PrintApi = {

  getPaymentMethods(email: string, memberId: number): AxiosPromise<String> {
    return printApi.getPaymentMethods(email, memberId, ops());
  },

  getDefaultPaymentMethod(email: string, memberId: number): AxiosPromise<String> {
    return printApi.getDefaultPaymentMethod(email, memberId, ops());
  },

  setDefaultPaymentMethod(email: string, memberId: number, paymentMethodId: string): AxiosPromise<String> {
    return printApi.setDefaultPaymentMethod(email, memberId, paymentMethodId, ops());
  },

  createPaymentIntent(params: string): AxiosPromise<String> {
    return printApi.createPaymentIntent1(params, ops());
  },

  updatePaymentIntent(params: string): AxiosPromise<String> {
    return printApi.updatePaymentIntent(params, ops());
  },

  getPaymentIntent(params: string): AxiosPromise<String> {
    return printApi.getPaymentIntent(params, ops());
  },

  submitPaymentIntent(paymentIntentId: string, paymentMethodId: string): AxiosPromise<String> {
    return printApi.submitPaymentIntent(paymentIntentId, paymentMethodId, ops());
  },

  applyCoupon(params: string): AxiosPromise<String> {
    return printApi.applyCoupon(params, ops());
  },

  saveUsedCoupon(coupon: string, memberId: number) {
    printApi.saveUsedCoupon(coupon, memberId, ops());
  },
};

export default PrintApi;
